import { render, staticRenderFns } from "./FirmaNewViva.vue?vue&type=template&id=ed8bf03c"
import script from "./FirmaNewViva.vue?vue&type=script&lang=js"
export * from "./FirmaNewViva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports